import React, { Component, Fragment } from 'react';
import { Button, Drawer, List } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import moment from "moment-jalaali";
import { PriceFormat } from '../scripts/helpers';
import { Constants } from '../scripts/settings';
import Resources from '../scripts/resources';

class UserView extends Component {
    render() {
        const { data, onClose, visible } = this.props;

        if (data.phones && !!data.phones.length)
            data.phones = data.phones.filter(p => p.phone !== data.phone);

        return (
            <Drawer visible={visible} closable={false} onClose={onClose} placement="left" width="600">
                <List>
                    <List.Item>
                        <List.Item.Meta title={Resources.fullName} description={data.name ? `${data.name} ${data.family}` : data.family} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.mobile} description={data.phone} />
                    </List.Item>
                    {data.phones && !!data.phones.length && <List.Item>
                        <List.Item.Meta title={Resources.otherPhones} description={<Fragment>{data.phones.map(o => <div key={o.id}>{o.phone}</div>)}</Fragment>} />
                    </List.Item>}
                    <List.Item>
                        <List.Item.Meta title={Resources.permission} description={Resources[data.level]} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.birthdate} description={data.dataBirth ? moment(data.dataBirth).format(Constants.jDateFormat) : '-'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.rank} description={data.type || '-'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.credit} description={PriceFormat(0)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.status} description={PriceFormat(!!parseInt(data.status) ? Resources.active : Resources.inactive)} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title="VIP" description={PriceFormat(!!parseInt(data.isVip) ? Resources.active : Resources.inactive)} />
                    </List.Item>
                    {data.address && data.address.length && <List.Item>
                        <List.Item.Meta title={Resources.addresses} description={<Fragment>{data.address.map(o => <div key={o.id}><Button type="link" href={`https://map.ir/lat/${o.lat}/lng/${o.lng}/z/${Constants.defaultZoom}`} target="_blank" style={{ border: 'none', float: 'left', height: 14, margin: '4px 10px 4px 0', padding: 0 }}><EnvironmentOutlined /></Button>{o.address}</div>)}</Fragment>} />
                    </List.Item>}
                </List>
            </Drawer>
        );
    }
};

export default UserView;